// extracted by mini-css-extract-plugin
export default {"collapsible-elm":"CollapsibleElm_collapsible-elm__59bZP"};